const TYPE_FILTER = 'type_filter';
const METRIC_FILTER = 'metric_filter';

export default class FilterInfo {
  type = null;
  filter_label = null;
  entity_value = null;
  allowed_values = [];
  filter_period = null;
  requirement_value = null;
  explanation = null;

  constructor(rawData) {
    if (rawData) {
      Object.assign(this, rawData);
    }
  }

  get isTypeFilter() {
    return this.type === TYPE_FILTER;
  }

  get isMetricFilter() {
    return this.type === METRIC_FILTER;
  }

  get headerLabel() {
    let label = this.filter_label;

    if (this.filter_period) {
      label += ' (' + this.filter_period + ')';
    }

    return label;
  }
}
